import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from '../../i18n';
import { Send } from '../../services/service.api';
import { Eye, EyeOff } from 'lucide-react';

export default function Login() {
  const { t, locale, toggleLocale } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error('Email et mot de passe requis');
    setLoading(true);
    try {
      const res = await Send('/auth/login', { email, password });
      if (res?.error) {
        toast.error(res.error);
      } else if (res?.token) {
        dispatch({ type: 'login', value: { user: res.user, token: res.token } });
        toast.success('Connexion réussie ! 🎉');
        navigate('/dashboard');
      }
    } catch {
      toast.error('Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* Lang toggle top right */}
      <div style={{ position: 'absolute', top: 20, right: 20, zIndex: 10 }}>
        <div className="lang-toggle">
          <button className={`lang-btn ${locale === 'fr' ? 'active' : ''}`} onClick={() => locale !== 'fr' && toggleLocale()}>FR</button>
          <button className={`lang-btn ${locale === 'en' ? 'active' : ''}`} onClick={() => locale !== 'en' && toggleLocale()}>EN</button>
        </div>
      </div>

      <div className="auth-card">
        {/* Logo */}
        <div className="auth-logo">
          <img
            src="/logo.png"
            alt="SavInvest"
            onError={e => { e.target.style.display = 'none'; }}
          />
          <div className="auth-logo-title">SavInvest</div>
          <div className="auth-logo-subtitle">{t.auth.loginSubtitle}</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">{t.auth.email}</label>
            <input
              id="login-email"
              type="email"
              className="form-control"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="exemple@mail.com"
              autoComplete="email"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">{t.auth.password}</label>
            <div className="relative">
              <input
                id="login-password"
                type={showPwd ? 'text' : 'password'}
                className="form-control"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                required
                style={{ paddingRight: 44 }}
              />
              <button
                type="button"
                onClick={() => setShowPwd(!showPwd)}
                style={{
                  position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                  background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer'
                }}
              >
                {showPwd ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          <button
            id="login-submit"
            type="submit"
            className="btn btn-primary btn-block btn-lg"
            disabled={loading}
            style={{ marginTop: 8 }}
          >
            {loading ? <span className="spinner" /> : null}
            {loading ? 'Connexion...' : t.auth.login}
          </button>
        </form>

        <div className="divider" />

        <p style={{ textAlign: 'center', fontSize: '0.875rem', color: 'var(--text-muted)' }}>
          {t.auth.noAccount}{' '}
          <Link to="/register" style={{ color: 'var(--primary)', fontWeight: 600, textDecoration: 'none' }}>
            {t.auth.register}
          </Link>
        </p>
      </div>
    </div>
  );
}
